import { SendMessageComponent } from './../send-message/send-message.component';
import { AddUserPostHiredDialogComponent } from '../add-user-post-hired-dialog/add-user-post-hired-dialog.component';
import { MessageBoxDialog } from '../message-box/message-box.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MessageBoxKanbanDialog } from '../message-box-kanban/message-box-kanban.component';
import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter, Inject, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpAuth } from '../../services/http-auth.service';
import { JobOffersService } from '../../services/job-offers.service';
import { JobsOffer } from '../../models/jobs-offer';
import { KanbanOfferStore } from '../state/kanban-offer.store';
import { KanbanOfferStoreList } from '../state/kanban-offer-list.store';
import { MdDialog } from '@angular/material';
import { Observable } from "rxjs";
import { ViewCvComponent } from '../view-cv/view-cv.component';
import { InviteService } from '../../services/invite.service';
import { ItemCandidateInviteComponent } from '../item-candidate-invite/item-candidate-invite.component';
import { KanbanComponent } from '../kanban/kanban.component';
import { JobReportComponent } from '../job-report/job-report.component';
import { CandidateService } from '../../services/candidate.service';
import { ApplyStatusService } from '../../services/apply-status.service';
import { InviteComponent } from '../invite/invite.component';
import { Constants } from '../constants';
import { ConfirmDeleteDialogComponent } from '../confirm-delete-dialog/confirm-delete-dialog.component';
import { environment } from '../../../environments/environment';
import { EditOfferVacancyDialogComponent } from '../edit-offer-vacancy-dialog/edit-offer-vacancy-dialog.component';
import { EventMassiveDialogComponent } from '../event-massive-dialog/event-massive-dialog.component';
import { HvRecommendedComponent } from '../hv-recommended/hv-recommended.component';
import { HvRecommendedService } from '../../services/hv-recommended.service';
import { TourService, IStepOption } from 'ngx-tour-ngx-bootstrap';


@Component({
  selector: 'app-view-invite',
  templateUrl: './view-invite.component.html',
  styleUrls: ['./view-invite.component.css'],
})
export class ViewInviteComponent implements OnInit {

  check_mandatory:boolean;

  TYPE_QUESTION_SN = 1;
  TYPE_QUESTION_TEXT = 2;
  TYPE_QUESTION_NUMBER = 3;

  jobId: string;
  job: JobsOffer;
  viewinvite: boolean;
  invitations: any;

  applyStatusList:any;
  users: any;
  usersFormReq: any;
  usersNotFormReq: any;

  usersReq: any;
  usersNotReq: any;

  checkMandatoryReq: boolean;
  checkMandatoryformReq: boolean;

  selectedUsers = 0;

  errorMessage: string;

  listPending: any;

  invite: boolean;
  initialized: boolean;

  loading_job: boolean;

  maxCandidates: number = 10000;

  page: number = 1;
  total: number = 0;

  recs: any;

  public STATUS = Constants;

  private landing = `${ environment.landing }`;

  constructor(
    private route: ActivatedRoute,
    private jobService: JobOffersService,
    private jobRecommended: HvRecommendedService,
    private _router: Router,
    @Inject(KanbanOfferStoreList) public KanbanOfferStoreList,
    private dialog: MdDialog,
    private inviteService: InviteService,
    public candidateService: CandidateService,
    private applyStatusService: ApplyStatusService,
    public tourService: TourService
  ) {

    this.tourService.initialize$.subscribe((steps: IStepOption[]) => {
      console.log('tour configured with these steps:', steps);
    }); 

    this.tourService.initialize([{
      anchorId: 'virtual',
      content: 'Invita candidatos a tu oferta laboral de nuestra base de datos o de una propia, estos candidatos pueden ser invitados de manera individual o masivamente.',
      placement: 'top',
      title: 'Invitar Entrevista Virtual',
    }, {
      anchorId: 'Hv',
      content: ' Revisa las hojas de vida que te recomendamos de nuestra base de datos y que se ajustan al 100% del perfil que estás buscando.',
      placement: 'top',
      title: 'Hv Recomendadas',
    }, {
      anchorId: 'mensaje masivo',
      content: 'Envia un mensaje a los candidatos de una columna del Kansan, estos no tienen posibilidad de contestar.',
      placement: 'top',
      title: 'Enviar Mensaje Masivo',
    }, {
      anchorId: 'evento masivo',
      content: 'Agenda a los candidatos de una columna a los diferentes eventos de tu proceso de selección, estos recibirán un sms, un correo y una notificación push que les informará del evento.',
      placement: 'top',
      title: 'Invitar Evento Masivo',
    }, {
      anchorId: 'generar informe',
      content: 'Mueve las hojas de vida de los candidatos postulados al estado de ‘seleccionados’ y podrás generar un informe y enviarlo al correo que desees.',
      placement: 'top',
      title: 'Generar Informe',
    }, {
      anchorId: 'kanban',
      content: 'Para visualizar mejor tu flujo de trabajo mueve a los candidatos entre los diferentes estados (columnas).',
      placement: 'top',
      title: 'Kanban',
    },
    {
      anchorId: 'perfil',
      content: 'En este botón puedes crear nuevos estados, selecciona mi configuración y luego en la pestaña ‘Listado de Estados’.',
      placement: 'left',
      title: 'Perfil',
    },    
    {
      anchorId: 'invitado virtual',
      content: 'Revisa los candidatos que están interesados, quiénes no, quién vio la invitación y quién no.',
      placement: 'top',
      title: 'Invitados Entrevista Virtual',
    }, 
    {
      anchorId: 'postulado',
      content: 'Puedes ver todos los candidatos que cumplen y no cumplen los requisitos obligatorios del perfil en esta columna.',
      placement: 'top',
      title: 'Postulados',
    }     
  ],
      {
       prevBtnTitle: 'Anterior',
       nextBtnTitle: 'Siguiente',
       endBtnTitle: 'Finalizar'
      }
    );
    //this.tourService.start();

   }

  ngOnInit() {
    // TODO: get users invite to jobId
    this.loading_job = true;
    this.KanbanOfferStoreList.restore();
    this.invite = true;
    this.check_mandatory = true;
    this.checkMandatoryReq = true;
    this.checkMandatoryformReq = true;
    this.usersReq = [];
    this.usersNotReq = [];
    this.usersFormReq = [];
    this.usersNotFormReq = [];
    this.KanbanOfferStoreList.list = [];

    this.applyStatusService.getApplyStatus().subscribe(
        data => {
          this.applyStatusList = data;
          this.route.params.subscribe(params => {
            this.jobId = params['jobId'];
            if (typeof this.jobId != 'undefined') {
              this.viewinvite = true;
              this.callhvrecommended2(this.jobId, 1);
              this.jobService.getOffersById(this.jobId).subscribe(
                data => {
                  this.job = data;
                  this.selectedUsers = this.job.users_selected;
                  this.loading_job = false;
                },
                error => {
                  this.errorMessage = <any>error;
                  this.loading_job = false;
                }
              );
              this.loadList();
              this.initialized = true;
            }
          });
          this.jobService.event.subscribe((data: JobsOffer) => {
            this.job = data;
            this.selectedUsers = this.job.users_selected;
            this.loadList();
          });
        },
        error => {
          this.errorMessage = <any>error;
        }
      );

  }


  callhvrecommended2(jobId,page){
    this.jobRecommended.getHvRecommendedByJob(jobId, page)
      .subscribe(
        data => {
        this.total = data.pagination.total;
        this.recs = data.recommended;
        },
        error => {
          this.errorMessage = <any>error;

          }
      );

  }

  loadList() {
    if (this.invite) {
      this.inviteService.getInviteByJob(this.jobId, 1, 1000, 1).subscribe(
        data => {
          this.listPending = [];
          this.users = data.invitations;
          this.users.forEach(element => {
            if (element.status === Constants.STATUS_PENDING ||
              element.status === Constants.STATUS_INTERESTED ||
              element.status === Constants.STATUS_NOT_INTERESTED ||
              element.status === Constants.STATUS_VISITED) {
              this.listPending.push(element);
            }
          });
        },
        error => {
          this.errorMessage = <any>error;
        }
      );
    }

    // Request Postulados
    let status = {
      applied: true,
      rejected: false,
      read: true,
      unread: true,
      screening: true,
      interview: true,
      test: true,
      selected: false,
      hired: false,
      configurable: false,
    };

    this.KanbanOfferStoreList.list = [];

    // Request Applied
    let kanban:KanbanOfferStore = new KanbanOfferStore(this.candidateService);
    kanban.changeFilters(status, 1, this.maxCandidates, this.jobId, true, true);
    kanban.statusName("Postulados");
    kanban.statusID(100);
    kanban.statusCustom(false);

    this.KanbanOfferStoreList.list.push(kanban);
    //this.offerStoreAppliedReq.changeFilters(status, 1, this.maxCandidates, this.jobId, true, true);


    kanban = new KanbanOfferStore(this.candidateService);
    kanban.changeFilters(status, 1, this.maxCandidates, this.jobId, true, false);
    kanban.statusName("Postulados que no cumplen");
    kanban.statusID(100);
    kanban.statusCustom(false);
    kanban.statusRequire(false);
    this.KanbanOfferStoreList.notfullfill =  kanban ;
    //this.offerStoreAppliedNotReq.changeFilters(status, 1, this.maxCandidates, this.jobId, true, false);

    this.applyStatusList.forEach(element => {
      let status = {
        applied: false,
        rejected: false,
        read: false,
        unread: false,
        screening: false,
        interview: false,
        test: false,
        selected: false,
        hired: false,
        configurable: true,
        item_conf: element.id
      };
      let kanban:KanbanOfferStore = new KanbanOfferStore(this.candidateService);
      kanban.changeFilters(status, 1, this.maxCandidates, this.jobId);
      kanban.statusName(element.name);
      kanban.statusID(element.id);
      kanban.statusCustom(true);
      this.KanbanOfferStoreList.list.push(kanban);
    });

    // Request Preselected
    status = {
      applied: false,
      rejected: false,
      read: false,
      unread: false,
      screening: false,
      interview: false,
      test: false,
      selected: true,
      hired: false,
      configurable: false,
    };

    // preseleccionados

    kanban = new KanbanOfferStore(this.candidateService);
    kanban.changeFilters(status, 1, this.maxCandidates, this.jobId);
    kanban.statusName("Pre Seleccionados");
    kanban.statusID(275);
    kanban.statusCustom(false);
    this.KanbanOfferStoreList.list.push(kanban);
    // this.offerStorePreselected.changeFilters(status, 1, this.maxCandidates, this.jobId);
    //this.offerStoreArray.push(this.offerStorePreselected);

    // Request Rejected
    status = {
      applied: false,
      rejected: true,
      read: false,
      unread: false,
      screening: false,
      interview: false,
      test: false,
      selected: false,
      hired: false,
      configurable: false,

    };

    // Rejected
    kanban = new KanbanOfferStore(this.candidateService);
    kanban.changeFilters(status, 1, this.maxCandidates, this.jobId);
    kanban.statusName("Rechazados");
    kanban.statusID(-1);
    kanban.statusCustom(false);
    this.KanbanOfferStoreList.list.push(kanban);
    // this.offerStoreRejected.changeFilters(status, 1, this.maxCandidates, this.jobId);

    // Request Hired
    status = {
      applied: false,
      rejected: false,
      read: false,
      unread: false,
      screening: false,
      interview: false,
      test: false,
      selected: false,
      hired: true,
      configurable: false,

    };

    // Hired
    kanban = new KanbanOfferStore(this.candidateService);
    kanban.changeFilters(status, 1, this.maxCandidates, this.jobId);
    kanban.statusName("Seleccionados (Generar Informe)");
    kanban.statusID(300);
    kanban.statusCustom(false);
    this.KanbanOfferStoreList.list.push(kanban);
    // this.offerStoreHired.changeFilters(status, 1, this.maxCandidates, this.jobId);

  }

  openDialogInvite(job) {
    let dialogRef = this.dialog.open(InviteComponent);
    dialogRef.componentInstance.createInvite=true;
    dialogRef.componentInstance.Job=job;
    dialogRef.componentInstance.nameComponent='Invitación';
    dialogRef.afterClosed().subscribe(result => {
      this.loadList();
      if (result != "YES") {
      }
    });
  }


  openDialogInviteMassiveEvent(job) {
    let dialogRef;
    dialogRef = this.dialog.open(EventMassiveDialogComponent);
    dialogRef.componentInstance.jobId = this.job.id;
    dialogRef.componentInstance.create = true;
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openDialogHvrecommended(job) {
      let dialogRef = this.dialog.open(HvRecommendedComponent, {
        data: {
          job: this.job,
          rec: this.recs,
          total_rec: this.total,
        }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != "YES") {
      }
    });
  }

  helpStatus(){
    this.dialog.open(MessageBoxKanbanDialog, {data: {html: 'Ahora puedes crear nuevos estados (columnas en el Kanban) según tus procesos de selección como: visita domiciliaria, entrevista verificada, opcionados, entre otros  y mover los candidatos que estén en este estados. Ve a la pestaña <a target="_blank" [routerLink]="["/pages/dashboard"]">Mi Cuenta - Mi Configuración - Listado de Estados</a> y ahora elije; lugar y nombre de la columna.', information: true, showIcon: true}});
  }

  checkReport(event){
    if (event != null){
      return false;
    }else{
      return true;
    }
  }

  openDialogMsg(job) {
    const jobArr = [];
    jobArr.push(job);

    let dialogRef = this.dialog.open(SendMessageComponent, {data: {
      nameComponent: 'offer', useFilter: true, job: job
    }});

    dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;
    });
}

  openDialogJobReport(job, type) {
    let dialogRef = this.dialog.open(JobReportComponent, {
        data: {
          job: this.job,
          create: type,
        }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != "YES") {
      }
    });
  }

  isSelectedUsers(event){
    if (event <= 0){
      return true;
    }
    return false;
  }

  openDialogDelete(job,status) {
      let dialogRef = this.dialog.open(ConfirmDeleteDialogComponent);
      dialogRef.componentInstance.deleteOffer=true;
      dialogRef.componentInstance.OfferID=job.id;
      dialogRef.componentInstance.OfferStatus=status;
      dialogRef.afterClosed().subscribe(result => {
        if (result != "NO")
          job.status = -6;
      });
  }

  getOffer(job) {
    this.jobService.getOffersById(job.id)
    .subscribe(
      data => {
        this.job = data;
        this.selectedUsers = this.job.users_selected;
      },
      error => this.errorMessage = <any>error
    );
  }

  putOffersStatus(job, status) {
    this.jobService.putOffersStatus(job.id, status)
      .subscribe(
        data => {},
        error => this.errorMessage = <any>error
      );
  }

  cloneJob(jobId) {
    this._router.navigate(['/pages/createoffer', jobId]);
  }

  viewJob(jobId) {
    this._router.navigate(['/pages/viewoffer', jobId]);
  }

  viewJobKanban(jobId) {
    this._router.navigate(['/pages/viewjob', jobId]);
  }

  gotoLanding (job) {
    if (job.status !== -4) {
      window.open(this.landing + job.id, '_blank');
    }
  }

  gotoReport(job) {
    if (job.status !== -4) {
      this._router.navigate(['/pages/reports', job.id]);
    }
  }

  gotoCalendar(job) {
    if (job.status !== -4) {
      this._router.navigate(['/pages/viewevent', job.id]);
    }
  }

  public out(event) {
    this.selectedUsers = parseInt(event);
  }

  openDialogEditOfferVacancy(job) {
    let dialogRef = this.dialog.open(EditOfferVacancyDialogComponent);
    dialogRef.componentInstance.jobsOffer = job;
    dialogRef.afterClosed().subscribe(result => {
      this.getOffer(job);
    });
  }

  openDialogUserPostHired(job) {
    let dialogRef = this.dialog.open(AddUserPostHiredDialogComponent);
    dialogRef.componentInstance.jobsOffer = job;
    dialogRef.afterClosed().subscribe(result => {
      this.getOffer(job);
    });
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/view-invite/view-invite.component.ts